import { ActionTypes } from '../constants/AppConstants';
import AppDispatcher from '../dispatcher/AppDispatcher';

const TutorialActions = {
    toggle (tutorialName, { open, dismissed, lastStage, currentStage }) {
        AppDispatcher.dispatch({
            tutorialName,
            open,
            dismissed,
            lastStage,
            currentStage,
            actionType: ActionTypes.TUTORIAL_TOGGLE
        });
    }
};

export default TutorialActions;
